var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625 6.75905C0.814815 6.75905 0.981482 6.67417 1.11574 6.54685L1.74537 5.9574V10.093C1.74537 10.8616 2.21296 11.3332 3.00463 11.3332H8.99537C9.78704 11.3332 10.2546 10.8616 10.2546 10.093V5.9574L10.8843 6.54685C11.0185 6.67417 11.1852 6.75905 11.375 6.75905C11.7269 6.75905 12 6.50441 12 6.16488C12 5.98569 11.9537 5.82536 11.7639 5.65088L9.95833 3.97213V1.02489C9.95833 0.807972 9.81944 0.666504 9.60185 0.666504H8.59722C8.37963 0.666504 8.23611 0.807972 8.23611 1.02489V2.36883L6.83796 1.06733C6.58333 0.83155 6.30556 0.71366 5.99537 0.71366C5.68982 0.71366 5.41667 0.83155 5.16204 1.06733L0.236111 5.65088C0.0462963 5.82536 0 5.98569 0 6.16488C0 6.50441 0.273148 6.75905 0.625 6.75905ZM7.38415 6.99483C7.38415 6.76848 7.24063 6.6223 7.01841 6.6223H4.986C4.76378 6.6223 4.61563 6.76848 4.61563 6.99483V10.0694H3.41193C3.13878 10.0694 2.986 9.91378 2.986 9.63084V4.80208L5.88878 2.09061C5.91656 2.06232 5.9536 2.04346 5.99989 2.04346C6.02767 2.04346 6.06066 2.05141 6.08713 2.06932L9.01378 4.80208V9.63084C9.01378 9.91378 8.861 10.0694 8.58785 10.0694H7.38415V6.99483Z",
    fill: "#A0A0A0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHome);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Home.a82da625099482f7b05c5e36b881760c.svg";